module.exports = __webpack_public_path__ + "static/media/how-it-works-step-4.833ca1c2.jpg";